import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import CircleSpinner from "../spinner/CircleSpinner";

const VacancyTemplate = ({
  title,
  clientID,
  location,
  createdBy,
  createdAt,
  vacancyID,
  payrate,
  description
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const Text = ({ header, text, ml }) => (
    <div className="tw-text-sm tw-flex-col tw-min-w-1/2 ">
      <p className="tw-font-bold ">{header}:</p>
      <p className={`tw-ml-${ml} `}>{text}</p>
    </div>
  );

  return (
    <div className="tw-flex tw-flex-col">
      <div
        onClick={() => setShow(!show)}
        className={`${
          show ? "tw-bg-yellow-100" : "tw-mb-5"
        }  tw-w-full tw-h-300 tw-bg-gray-100  tw-p-3 tw-flex tw-justify-between tw-border-2 hover:tw-border-black tw-cursor-pointer`}
      >
        <h1>
          {" "}
          {title} - {clientID}
        </h1>
        <ChevronDownIcon className="tw-h-6 tw-w-6" aria-hidden="true" />
      </div>
      {show ? (
        <div className="tw-bg-white tw-border-b-2 tw-border-r-2 tw-border-l-2 tw-mb-5 tw-p-3 ">
          <div className="tw-flex-col tw-flex sm:tw-flex-row tw-justify-between sm:tw-mb-2 tw-mb-0">
            <Text header="Creator Email" text={createdBy} ml={0} />
          </div>
          <div className="tw-flex-col tw-flex sm:tw-flex-row tw-justify-between">
            <Text header="Location" text={location} ml={0} />
            <Text header="Date Created" text={createdAt} ml={0} />
          </div>
          <div className="tw-flex-col tw-flex sm:tw-flex-row tw-justify-between">
            <Text header="Pay Rate" text={`£${payrate.toFixed(2)}`} ml={0} />
            <Text
              header="Description"
              text={`${description.substr(0, 150)}${
                description.length <= 150 ? "" : "..."
              }`}
              ml={0}
            />
          </div>
          <div className="tw-pt-2 tw-flex tw-justify-end">
            <Link to={`/vacancies/create?${vacancyID}`}>
              <button
                className="hover:tw-bg-green-300 tw-cursor-pointer tw-h-10 tw-bg-green-500 tw-rounded-lg tw-text-white tw-px-3"
                onClick={() => {
                  document.body.style.overflowY = "";
                  setLoading(true);
                }}
              >
                {loading ? <CircleSpinner /> : "Use Template"}
              </button>
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default VacancyTemplate;

// const VacancyTemplate = ({
//   title,
//   clientID,
//   location,
//   createdBy,
//   createdAt,
//   approverEmail,
//   vacancyID
// }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const Text = ({ header, text, ml, styles }) => (
//     <div className={`${styles} tw-text-sm tw-flex-col tw-min-w-1/2`}>
//       <p className="tw-font-bold ">{header}:</p>
//       <p className={`tw-ml-${ml} `}>{text}</p>
//     </div>
//   );

//   return (
//     <div className="tw-flex tw-flex-col">
//       <div
//         onClick={() => setShow(!show)}
//         className={`${
//           show ? "tw-bg-yellow-100" : "tw-mb-5"
//         }  tw-w-full tw-h-300 tw-bg-gray-100  tw-p-3 tw-flex tw-justify-between tw-border-2 hover:tw-border-black tw-cursor-pointer`}
//       >
//         <h1>
//           {" "}
//           {title} - {clientID}
//         </h1>
//         <ChevronDownIcon className="tw-h-6 tw-w-6" aria-hidden="true" />
//       </div>
//       {show ? (
//         <div className="tw-bg-white tw-border-b-2 tw-border-r-2 tw-border-l-2 tw-mb-5 tw-p-3 ">
//           <div className="sm:tw-flex-row xs:tw-flex-col tw-flex tw-justify-between sm:tw-mb-2 tw-mb-0">
//             <Text header="Creator Email" text={createdBy} ml={0} styles="tw-bg-yellow-100"/>
//             <Text header="Approver Email" text={approverEmail} ml={0} styles="tw-bg-yellow-200" />
//           </div>
//           <div className="sm:tw-flex-row xs:tw-flex-col tw-flex tw-justify-between">
//             <Text header="Location" text={location} ml={0} styles="tw-bg-yellow-100" />
//             <Text header="Date Created" text={createdAt} ml={0} styles="tw-bg-yellow-100"/>
//           </div>
//           <div className="tw-pt-2 tw-flex tw-justify-end">
//             {/* <Link href={`/create-vacancy?${vacancyID}`}> */}
//             <button
//               className="hover:tw-bg-green-300 tw-cursor-pointer tw-h-10 tw-bg-green-500 tw-rounded-lg tw-text-white tw-px-3"
//               onClick={() => {
//                 document.body.style.overflowY = "";
//                 setLoading(true);
//               }}
//             >
//               {loading ? <CircleSpinner /> : "Use Template"}
//             </button>
//             {/* </Link> */}
//           </div>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default VacancyTemplate;
